/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Cap_Spaces_Create_DatasetInputs */



/**
* | output |
* | --- |
* | "Create dataset spaces" |
*
* @param {Rights_Cap_Spaces_Create_DatasetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_cap_spaces_create_dataset = /** @type {((inputs?: Rights_Cap_Spaces_Create_DatasetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Cap_Spaces_Create_DatasetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Datensatz-Spaces erstellen")
	return /** @type {LocalizedString} */ ("Create dataset spaces")
});